module.exports = __webpack_public_path__ + "img/34.f3efa129.png";